// extracted by mini-css-extract-plugin
export var breadcrumb = "_1b-3";
export var breadcrumbArrow = "_1b-4";
export var breadcrumbs = "_1b-0";
export var link = "_1b-5";
export var sm = "_1b-1";
export var xs = "_1b-2";